let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dLcQ9")).then(() => parcelRequire('ibOo1'));